import { fetchData } from '../../fetchapi/fetchapi.js';

// Mini pub/sub for cross-component refreshes (sidebar badge ↔ Alerts page)
const subscribers = new Set();
export const subscribeAlertsChange = (cb) => {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
};
const notifyAlertsChange = () => {
  subscribers.forEach((cb) => {
    try { cb(); } catch (e) { console.error(e); }
  });
};

export const fetchAlertsFeed = async (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();
  return fetchData(`alerts/feed${qs ? '?' + qs : ''}`);
};

export const fetchAlertsBadge = async () => fetchData('alerts/badge');

export const acknowledgeAlert = async (id) => {
  const res = await fetchData(`alerts/${id}/acknowledge`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  notifyAlertsChange();
  return res;
};

export const resolveAlert = async (id) => {
  const res = await fetchData(`alerts/${id}/resolve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  notifyAlertsChange();
  return res;
};

export const deleteAlerts = async (ids) => {
  const res = await fetchData('alerts/bulk-delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids }),
  });
  notifyAlertsChange();
  return res;
};
